enum ERouteAccountant {
	PATH_APP_LAYOUT = '/',
	PATH_DASHBOARD = '/',
	PATH_INVOICES = '/invoices',
	PATH_EXPENSES = '/expenses',
}

export default ERouteAccountant